
const digest = '058626fc8bf229cd6758ad3d2e061bd976bb557353ed6800564fff9d6868d49b';
const css = `._embedInline_1gdfa_1 {
  display: inline-block;
  vertical-align: middle;
  margin: 0.5em;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"embedInline":"_embedInline_1gdfa_1"};
export { css, digest };
  